export const MAX_LABEL_LENGTH = 255;
export const MAX_EXPIRATION_DATE = new Date('2038-01-18'); // < Max date for 32-bit systems

// Validation functions
const validateLabel = value => {
  if (value && value.length > MAX_LABEL_LENGTH) {
    return `Label cannot exceed ${MAX_LABEL_LENGTH} characters`;
  }
  return undefined;
};

const validateExpirationDate = value => {
  if (!value) return undefined;

  const date = new Date(value);
  const now = new Date();

  if (Number.isNaN(date.getTime())) {
    return 'Invalid date';
  }

  if (date <= now) {
    return 'Expiration date must be in the future';
  }

  if (date > MAX_EXPIRATION_DATE) {
    return 'Date is too far in the future';
  }

  return undefined;
};

export const validate = values => {
  const errors = {};

  const labelError = validateLabel(values.label);
  if (labelError) errors.label = labelError;

  const dateError = validateExpirationDate(values.expirationDate);
  if (dateError) errors.expirationDate = dateError;

  return errors;
};
